import React, { useState, useMemo, useCallback, useEffect } from "react";
// import { match } from "react-router";
// import { MatchParams } from "src/routes";
// import { UserStore } from "src/stores";
import { Button, Heading, Paper } from "src/components";
// import { Chat } from "./chat";
import { MessengerStyle } from "./style";

// // https://chatscope.io/features/

// import {
//   BasicStorage,
//   ChatMessage,
//   ChatProvider,
//   Conversation,
//   ConversationId,
//   ConversationRole,
//   IStorage,
//   MessageContentType,
//   Participant,
//   Presence,
//   TypingUsersList,
//   UpdateState,
//   User,
//   UserStatus,
// } from "@chatscope/use-chat";
// import { ExampleChatService } from "@chatscope/use-chat/dist/examples";
// import { nanoid } from "nanoid";
// import { AutoDraft } from "@chatscope/use-chat/dist/enums/AutoDraft";

// export const meModel = {
//   name: "Me",
//   avatar: "https://eu.ui-avatars.com/api/?name=Me",
// };

// export const akaneModel = {
//   name: "Akane Doe",
//   avatar: "https://eu.ui-avatars.com/api/?name=Akane+Doe",
// };

// export const eliotModel = {
//   name: "Eliot Maccadam",
//   avatar: "https://eu.ui-avatars.com/api/?name=Eliot+Maccadam",
// };

// export const emilyModel = {
//   name: "Emily Reffington",
//   avatar: "https://eu.ui-avatars.com/api/?name=Emily+Reffington",
// };

// export const joeModel = {
//   name: "Joe Lewinsky",
//   avatar: "https://eu.ui-avatars.com/api/?name=Joe+Lewinsky",
// };
// export const users = [akaneModel, eliotModel, emilyModel, joeModel];

// // sendMessage and addMessage methods can automagically generate id for messages and groups
// // This allows you to omit doing this manually, but you need to provide a message generator
// // The message id generator is a function that receives message and returns id for this message
// // The group id generator is a function that returns string
// const messageIdGenerator = (message: ChatMessage<MessageContentType>) =>
//   nanoid();
// const groupIdGenerator = () => nanoid();

// const meSorage = new BasicStorage({ groupIdGenerator, messageIdGenerator });
// const akaneStorage = new BasicStorage({ groupIdGenerator, messageIdGenerator });
// const eliotStorage = new BasicStorage({ groupIdGenerator, messageIdGenerator });
// const emilyStorage = new BasicStorage({ groupIdGenerator, messageIdGenerator });
// const joeStorage = new BasicStorage({ groupIdGenerator, messageIdGenerator });

// // Create serviceFactory
// const serviceFactory = (storage: IStorage, updateState: UpdateState) => {
//   return new ExampleChatService(storage, updateState);
// };

// const me = new User({
//   id: meModel.name,
//   presence: new Presence({ status: UserStatus.Available, description: "" }),
//   firstName: "",
//   lastName: "",
//   username: meModel.name,
//   email: "",
//   avatar: meModel.avatar,
//   bio: "",
// });

// const akane = new User({
//   id: akaneModel.name,
//   presence: new Presence({ status: UserStatus.Available, description: "" }),
//   firstName: "",
//   lastName: "",
//   username: akaneModel.name,
//   email: "",
//   avatar: akaneModel.avatar,
//   bio: "",
// });

// const emily = new User({
//   id: emilyModel.name,
//   presence: new Presence({ status: UserStatus.Available, description: "" }),
//   firstName: "",
//   lastName: "",
//   username: emilyModel.name,
//   email: "",
//   avatar: emilyModel.avatar,
//   bio: "",
// });

// const eliot = new User({
//   id: eliotModel.name,
//   presence: new Presence({ status: UserStatus.Available, description: "" }),
//   firstName: "",
//   lastName: "",
//   username: eliotModel.name,
//   email: "",
//   avatar: eliotModel.avatar,
//   bio: "",
// });

// const joe = new User({
//   id: joeModel.name,
//   presence: new Presence({ status: UserStatus.Available, description: "" }),
//   firstName: "",
//   lastName: "",
//   username: joeModel.name,
//   email: "",
//   avatar: joeModel.avatar,
//   bio: "",
// });

// const chats = [
//   { name: "Me", storage: meSorage },
//   { name: "Akane", storage: akaneStorage },
//   { name: "Eliot", storage: eliotStorage },
//   { name: "Emily", storage: emilyStorage },
//   { name: "Joe", storage: joeStorage },
// ];

// function createConversation(id: ConversationId, name: string): Conversation {
//   return new Conversation({
//     id,
//     participants: [
//       new Participant({
//         id: name,
//         role: new ConversationRole([]),
//       }),
//     ],
//     unreadCounter: 0,
//     typingUsers: new TypingUsersList({ items: [] }),
//     draft: "",
//   });
// }

// // Add users and conversations to the states
// chats.forEach((c) => {
//   users.forEach((u) => {
//     if (u.name !== c.name) {
//       c.storage.addUser(
//         new User({
//           id: u.name,
//           presence: new Presence({
//             status: UserStatus.Available,
//             description: "",
//           }),
//           firstName: "",
//           lastName: "",
//           username: u.name,
//           email: "",
//           avatar: u.avatar,
//           bio: "",
//         })
//       );

//       const conversationId = nanoid();

//       const myConversation = c.storage
//         .getState()
//         .conversations.find(
//           (cv) =>
//             typeof cv.participants.find((p) => p.id === u.name) !== "undefined"
//         );
//       if (!myConversation) {
//         c.storage.addConversation(createConversation(conversationId, u.name));

//         const chat = chats.find((chat) => chat.name === u.name);

//         if (chat) {
//           const hisConversation = chat.storage
//             .getState()
//             .conversations.find(
//               (cv) =>
//                 typeof cv.participants.find((p) => p.id === c.name) !==
//                 "undefined"
//             );
//           if (!hisConversation) {
//             chat.storage.addConversation(
//               createConversation(conversationId, c.name)
//             );
//           }
//         }
//       }
//     }
//   });
// });
// export interface IMessengerProps {
//   userStore?: UserStore;
//   match: match<MatchParams>; // This is injected so it has to be called match
// }

// export const Messenger = (props: IMessengerProps): JSX.Element => {
//   return (
//     <Paper>
//       <MessengerStyle />
//       <ChatProvider
//         serviceFactory={serviceFactory}
//         storage={akaneStorage}
//         config={{
//           typingThrottleTime: 250,
//           typingDebounceTime: 900,
//           debounceTyping: true,
//           autoDraft: AutoDraft.Save | AutoDraft.Restore,
//         }}
//       >
//         <Chat user={me} />
//       </ChatProvider>
//     </Paper>
//   );
// };


export const Messenger = (): JSX.Element => {
  return (
    <Paper>
      <MessengerStyle />
      
    </Paper>
  );
};


